import { testimonialsQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/refinancing-static.ts';
import { RefinancingPage } from './_components/refinancing-page.tsx';

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const testimonials = await queryClient.query(testimonialsQuery());
  return { testimonials };
}

export default function RefinancingStatic({ loaderData }: Route.ComponentProps) {
  return <RefinancingPage testimonials={loaderData.testimonials} />;
}
